export const formDataTestIds = {
  deletedButton: 'delete-button',
  fileCardUploadingButton: 'file-card-uploading-button',
  fileCardClearButton: 'file-card-clear-button',
  itemAddedValue: 'item-added-value',
  cardNumber: 'card-number',
  preferredPharmacy: {
    pharmacySearch: 'pharmacy-search',
    pharmacySearchDisplay: { text: 'pharmacy-search-display', button: 'pharmacy-search-display-reset-btn' },
  },
};
